import React, { useEffect } from 'react';
import './styles/DraftLeague.css';
import { Link } from 'react-router-dom';
import basketballImg from './assets/basketball.png';

const Rules = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--basketball-image',
      `url(${basketballImg})`
    );
  }, []);

  return (
    <div className="draft-league-container">
      {/* Compact Hero Section */}
      <div className="hero hero-compact">
        {/* Background */}
        <div className="hero-background" />
        <div className="hero-overlay" />

        {/* Floating elements */}
        <div className="floating-element-1" />
        <div className="floating-element-2" />
        <div className="floating-element-3" />

        {/* Main Content */}
        <div className="hero-content">
          <h1 className="hero-title">
            Grass Valley
            <br />
            <span className="hero-title-bold">Draft League</span>
          </h1>
        </div>
      </div>

      {/* Rules Document Section */}
      <div className="rules-document-section">
        <div className="iframe-container">
          <iframe
            src="https://docs.google.com/document/d/e/2PACX-1vS3TyVgOhvGXPtv3ydfaci46-6NUAWf5OjzRAyhmr-DhGA1nJPtD1X2zAxnuFq8fL0c1VeWx9UqiL0o/pub?embedded=true"
            className="rules-iframe"
            title="Draft League Rules"
          />
        </div>
      </div>

      {/* Home Button Section */}
      <div className="rules-nav-section">
        <div className="cards-container">
          <Link to="/" className="card-link">
            <div className="card">
              <h3 className="card-title">← Back to Home</h3>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Rules;
